/* eslint-disable react/jsx-wrap-multilines */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Divider from '@mui/material/Divider';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Checkbox from '@mui/material/Checkbox';

import SearchIcon from '@mui/icons-material/Search';

import Button from '@ts-core/components/Button';

import StudentsSelectorList from './StudentsSelectorList';

const useStyles = makeStyles((theme) => ({
  searchTextField: {
    marginBottom: theme.spacing(2),
  },
}));

const StudentsSelector = (props) => {
  const classes = useStyles();
  const {
    submitting,
    students,
    selectedStudents,
    query,
    allStudentSelected,
    noStudentsSelected,
    loading,
    isStudentSelected,
    onToggleStudent,
    onToggleAll,
    onSearchStudent,
    onConfirmSelection,
    submitButtonTitle,
    disabled,
  } = props;

  const handleSearchTextChange = useCallback(
    (event) => {
      onSearchStudent(event.target.value);
    },
    [onSearchStudent]
  );

  const handleConfirmSelection = useCallback(() => {
    onConfirmSelection(selectedStudents);
  }, [onConfirmSelection, selectedStudents]);

  return (
    <Box width="100%">
      {(students.length > 0 || !!query?.length) && (
        <>
          <TextField
            variant="standard"
            fullWidth
            label={<FormattedMessage id="addStudentsToGroup.searchPlaceholder" />}
            id="simple-start-adornment"
            className={classes.searchTextField}
            onChange={handleSearchTextChange}
            value={query || ''}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
          {students.length > 0 && (
            <FormControlLabel
              classes={{ root: classes.selectAllCheckbox }}
              control={
                <Checkbox
                  checked={allStudentSelected}
                  onChange={onToggleAll}
                  color="secondary"
                  indeterminate={!allStudentSelected && !noStudentsSelected}
                />
              }
              label={<FormattedMessage id="selectAll" />}
            />
          )}
          <Divider />
        </>
      )}
      <StudentsSelectorList students={students} onToggleStudent={onToggleStudent} isStudentSelected={isStudentSelected} />
      <Box display="flex" flexDirection="row" justifyContent="flex-end" mt={2}>
        <Button
          variant="contained"
          color="primary"
          loading={submitting}
          disabled={disabled || loading || submitting}
          onClick={handleConfirmSelection}
        >
          {submitButtonTitle}
        </Button>
      </Box>
    </Box>
  );
};

StudentsSelector.propTypes = {
  students: PropTypes.array,
  selectedStudents: PropTypes.array,
  loading: PropTypes.bool,
  query: PropTypes.string,
  allStudentSelected: PropTypes.bool,
  disabled: PropTypes.bool,
  noStudentsSelected: PropTypes.bool,
  submitting: PropTypes.bool,
  submitButtonTitle: PropTypes.node,

  isStudentSelected: PropTypes.func.isRequired,
  onToggleStudent: PropTypes.func.isRequired,
  onToggleAll: PropTypes.func.isRequired,
  onSearchStudent: PropTypes.func,

  onConfirmSelection: PropTypes.func.isRequired,
};

StudentsSelector.defaultProps = {
  submitting: false,
  loading: false,
  disabled: false,
  query: undefined,
  allStudentSelected: false,
  noStudentsSelected: false,
  onSearchStudent: undefined,
  students: [],
  selectedStudents: [],
  submitButtonTitle: <FormattedMessage id="addStudentForm.button.add" />,
};

export default StudentsSelector;
